import {fetchWrapper} from './fetch';
import {config} from "../utils2";


const remoteAPI = config.get_remote_api() + "/api"

const accountAPI = "/accounts"
const deviceAPI = "/devices"
const iconAPI = "/icons"
const deviceTagAPI = "/device_tags"


const getSearchParams = x => new URLSearchParams(Object.entries(x).filter(([k, v]) => v !== undefined && v !== null && v !== ""))

/* Exposed functions */
export const backend = {
    signup,
    verifyEmail,
    resendEmail,
    forgotPassword,
    resetPassword,
    login,
    refreshToken,
    logout,

    // EditUser API
    getUserCount,
    getUserList,
    getUserDetails,
    addUser,
    editUser,
    deleteUser,
    //createUser,

    // Device API
    getDeviceCount,
    getDeviceList,
    getDeviceDetails,
    addDevice,
    editDevice,
    deleteDevice,

    // Tag API
    getDeviceTagCount,
    getDeviceTagList,
    getDeviceTagDetails,
    addDeviceTag,
    editDeviceTag,
    deleteDeviceTag,

    // Icons API
    getIconCount,
    getIconList,
    getIconDetails,

}

/**
 * Signup by sending a valid JSON object containing at least email, password, and accept.
 *
 * @param payload E.g., {"firstname":"Luca", "username":"luca.pascarella@gmail.com", "password":"Password1234", "accept": true}
 * @returns {Promise<Response>}
 */
function signup(payload) {
    return fetchWrapper.post(`${remoteAPI}${accountAPI}/signup`, payload)
}

/**
 * Verify email API by passing a valid JSON object containing the token received by email.
 *
 * @param payload E.g., {"token":"JWT_valid_token"}
 * @returns {Promise<Response>}
 */
function verifyEmail(payload) {
    return fetchWrapper.post(`${remoteAPI}${accountAPI}/verify-email`, payload)
}

/**
 * Request a new email with a verification link. A valid JSON object containing the email to which send the reset link.
 *
 * @param payload E.g., {"email": "luca.pascarella@gmail.com"}
 * @returns {Promise<Response>}
 */
function resendEmail(payload) {
    return fetchWrapper.post(`${remoteAPI}${accountAPI}/resend-email`, payload)
}

/**
 * Request a password reset link. A valid JSON object containing the email to which send the reset link.
 *
 * @param payload E.g., {"email": "luca.pascarella@gmail.com"}
 * @returns {Promise<Response>}
 */
function forgotPassword(payload) {
    return fetchWrapper.post(`${remoteAPI}${accountAPI}/forgot-password`, payload)
}

/**
 * Change the current password.
 * The request is a valid JSON object containing the token received by email and the new password
 *
 * @param payload E.g., {"token":"TOKEN RECEIVED BY EMAIL", "password":"new5tr0ng5ecret"}
 * @returns {Promise<Response>}
 */
function resetPassword(payload) {
    return fetchWrapper.post(`${remoteAPI}${accountAPI}/reset-password`, payload)
}

/**
 * Authenticate a user session.
 *
 * @param payload E.g., {"username": "luca.pascarella@gmail.com", "password":"Password1234"}
 * @returns {Promise<{success:bool, data:{token:{jwt:string, refresh_at:string}, user:{username:string, first_name:string, last_name:string, location:string}}}>}
 */
function login(payload) {
    // Pass through Remote server. Submit POST
    return fetchWrapper.post(`${remoteAPI}${accountAPI}/login`, payload)
}

/**
 * Refresh JWT (session token)
 *
 * @returns {Promise<{success:bool, data:{token:str, refresh_at:str}}>}
 */
function refreshToken(jwt) {
    // Send an empty GET request and wait for a fresh JWT
    return fetchWrapper.get(`${remoteAPI}${accountAPI}/refresh-token`, jwt)
}

/**
 * Terminate a user session and delete data.
 */
function logout() {
    // Actually doing nothing
    return Promise.resolve()
}


/* EditUser API */

function getUserCount(jwt, user_id, query, abort) {
    const searchParams = getSearchParams({query})
    if (Object.entries(searchParams).length > 0)
        return fetchWrapper.get(`${remoteAPI}${accountAPI}/count?${searchParams}`, jwt, abort);
    else
        return fetchWrapper.get(`${remoteAPI}${accountAPI}/count?${searchParams}`, jwt, abort);
}

function getUserList(jwt, user_id, offset, limit, query, order_by, abort) {
    const params = {offset, limit, query, order_by}
    const searchParams = getSearchParams(params)
    if (Object.entries(searchParams).length > 0)
        return fetchWrapper.get(`${remoteAPI}${accountAPI}/list?${searchParams}`, jwt, abort);
    else
        return fetchWrapper.get(`${remoteAPI}${accountAPI}/list?`, jwt, abort);
}

function getUserDetails(jwt, targetId) {
    return fetchWrapper.get(`${remoteAPI}${accountAPI}/${targetId}`, jwt);
}

/**
 * Add user. Admin management
 *
 * @param jwt
 * @param requestUserId
 * @param payload
 * @returns {Promise<Response>}
 */
function addUser(jwt, requestUserId, payload) {
    return fetchWrapper.post(`${remoteAPI}${accountAPI}/create`, payload, jwt)
}

/**
 * Edit user. Admin management
 *
 * @param jwt
 * @param requestUserId
 * @param targetUserId
 * @param payload
 * @returns {Promise<{success:bool, data:{username:string, first_name:string, last_name:string, location:string}}>}
 */
function editUser(jwt, requestUserId, targetUserId, payload) {
    return fetchWrapper.put(`${remoteAPI}${accountAPI}/${targetUserId}`, payload, jwt);
}

/**
 * Delete user. Admin management
 *
 * @param jwt
 * @param requestUserId
 * @param targetUserId
 * @returns {Promise<Response>}
 */
function deleteUser(jwt, requestUserId, targetUserId) {
    return fetchWrapper.delete(`${remoteAPI}${accountAPI}/${targetUserId}`, jwt);
}

// /**
//  * Signup process to create a new user
//  *
//  * @param payload
//  * @returns {Promise<Response>}
//  */
// function createUser(payload) {
//     return signup(payload)
// }


/* Device API */

/**
 * Det Device count post query
 *
 * @param jwt
 * @param user_id
 * @param query
 * @param abort
 * @returns {Promise<{data:int, success:bool, msg:string}>}
 */
function getDeviceCount(jwt, user_id, query, abort) {
    const searchParams = getSearchParams({query})
    if (Object.entries(searchParams).length > 0)
        return fetchWrapper.get(`${remoteAPI}${deviceAPI}/count/${user_id}?${searchParams}`, jwt, abort);
    else
        return fetchWrapper.get(`${remoteAPI}${deviceAPI}/count/${user_id}`, jwt, abort);
}


/**
 * Get device list post query and ordering
 *
 * @param jwt
 * @param user_id
 * @param offset
 * @param limit
 * @param query
 * @param order_by
 * @param abort
 * @returns {Promise<{data:[{id:int, name:string, device_id:string}], success:bool, msg:string}>}
 */
function getDeviceList(jwt, user_id, offset, limit, query, order_by, abort) {
    const params = {offset, limit, query, order_by}
    const searchParams = getSearchParams(params)
    if (Object.entries(searchParams).length > 0)
        return fetchWrapper.get(`${remoteAPI}${deviceAPI}/list/${user_id}?${searchParams}`, jwt, abort);
    else
        return fetchWrapper.get(`${remoteAPI}${deviceAPI}/list/${user_id}`, jwt, abort);
}

/**
 * Get device details
 *
 * @param jwt
 * @param user_id
 * @param device_id
 * @returns
 */
function getDeviceDetails(jwt, user_id, device_id) {
    return fetchWrapper.get(`${remoteAPI}${deviceAPI}/${user_id}/${device_id}`, jwt);
}

/**
 * Add a new device
 *
 * @param jwt
 * @param user_id
 * @param payload {name:string, key:string, tag:string}
 * @returns {Promise<{data:{id:int, user_id:int, device_id:string, name:string}, success:bool, msg:string}>}
 */
function addDevice(jwt, user_id, payload) {
    return fetchWrapper.post(`${remoteAPI}${deviceAPI}/${user_id}`, payload, jwt);
}

/**
 * Edit an existent device
 *
 * @param jwt
 * @param user_id
 * @param device_id
 * @param payload
 * @returns
 */
function editDevice(jwt, user_id, device_id, payload) {
    return fetchWrapper.put(`${remoteAPI}${deviceAPI}/${user_id}/${device_id}`, payload, jwt);
}

/**
 * Delete a device
 *
 * @param jwt
 * @param user_id
 * @param device_id
 * @returns {Promise<{success:bool, msg:string}>}
 */
function deleteDevice(jwt, user_id, device_id) {
    return fetchWrapper.delete(`${remoteAPI}${deviceAPI}/${user_id}/${device_id}`, jwt);
}


/* Tag API */

/**
 * Get tag count post query
 *
 * @param jwt
 * @param user_id
 * @param query
 * @param abort
 * @returns {Promise<{data:int, success:bool, msg:string}>}
 */
function getDeviceTagCount(jwt, user_id, query, abort) {
    const searchParams = getSearchParams({query})
    if (Object.entries(searchParams).length > 0)
        return fetchWrapper.get(`${remoteAPI}${deviceTagAPI}/count/${user_id}?${searchParams}`, jwt, abort);
    else
        return fetchWrapper.get(`${remoteAPI}${deviceTagAPI}/count/${user_id}`, jwt, abort);
}

/**
 * Get tag list post query
 *
 * @param jwt
 * @param user_id
 * @param offset
 * @param limit
 * @param query
 * @param order_by
 * @param abort
 * @returns {Promise<{data:[{id:int, name:string, variant:string, icon_id:int}], success:bool, msg:string}>}
 */
function getDeviceTagList(jwt, user_id, offset, limit, query, order_by, abort) {
    const params = {offset, limit, query, order_by}
    const searchParams = getSearchParams(params)
    if (Object.entries(searchParams).length > 0)
        return fetchWrapper.get(`${remoteAPI}${deviceTagAPI}/list/${user_id}?${searchParams}`, jwt, abort);
    else
        return fetchWrapper.get(`${remoteAPI}${deviceTagAPI}/list/${user_id}`, jwt, abort);
}

/**
 * Get tag details
 *
 * @param jwt
 * @param user_id
 * @param device_tag_id
 * @returns {Promise<{data:{id:int, user_id:int, device_id:string, name:string, variant:string}, success:bool, msg:string}>}
 */
function getDeviceTagDetails(jwt, user_id, device_tag_id) {
    return fetchWrapper.get(`${remoteAPI}${deviceTagAPI}/${user_id}/${device_tag_id}`, jwt);
}

/**
 * Add a new tag
 *
 * @param jwt
 * @param user_id
 * @param payload {name:string, icon_id:int, variant:str}
 * @returns {Promise<{data:{id:int, user_id:int, device_id:string, name:string, variant:string}, success:bool, msg:string}>}
 */
function addDeviceTag(jwt, user_id, payload) {
    return fetchWrapper.post(`${remoteAPI}${deviceTagAPI}/${user_id}`, payload, jwt);
}

/**
 * Edit a tag
 *
 * @param jwt
 * @param user_id
 * @param device_tag_id
 * @param payload
 * @returns
 */
function editDeviceTag(jwt, user_id, device_tag_id, payload) {
    return fetchWrapper.put(`${remoteAPI}${deviceTagAPI}/${user_id}/${device_tag_id}`, payload, jwt);
}

/**
 * Delete a tag
 *
 * @param jwt
 * @param user_id
 * @param device_tag_id
 * @returns {Promise<{success:bool, msg:string}>}
 */
function deleteDeviceTag(jwt, user_id, device_tag_id) {
    return fetchWrapper.delete(`${remoteAPI}${deviceTagAPI}/${user_id}/${device_tag_id}`, jwt);
}


/* Icon API */

/**
 * Get icon count post query
 *
 * @param jwt
 * @param user_id
 * @param query
 * @param abort
 * @returns {Promise<{data:int, success:bool, msg:string}>}
 */
function getIconCount(jwt, user_id, query, abort) {
    const searchParams = getSearchParams({query})
    if (Object.entries(searchParams).length > 0)
        return fetchWrapper.get(`${remoteAPI}${iconAPI}/count/${user_id}?${searchParams}`, jwt, abort);
    else
        return fetchWrapper.get(`${remoteAPI}${iconAPI}/count/${user_id}`, jwt, abort);
}

/**
 * Get icon list post query and order by
 *
 * @param jwt
 * @param user_id
 * @param offset
 * @param limit
 * @param query
 * @param order_by
 * @param abort
 * @returns {Promise<{data:[{id:int, name:string, icon_id: int}], success:bool, msg:string}>}
 */
function getIconList(jwt, user_id, offset, limit, query, order_by, abort) {
    const params = {offset, limit, query, order_by}
    const searchParams = getSearchParams(params)
    if (Object.entries(searchParams).length > 0)
        return fetchWrapper.get(`${remoteAPI}${iconAPI}/list/${user_id}?${searchParams}`, jwt, abort);
    else
        return fetchWrapper.get(`${remoteAPI}${iconAPI}/list/${user_id}`, jwt, abort);
}

/**
 * Get icon details
 *
 * @param jwt
 * @param user_id
 * @param icon_id
 * @returns {Promise<{data:{id:int, user_id:int, device_id:string, name:string, variant:string}, success:bool, msg:string}>}
 */
function getIconDetails(jwt, user_id, icon_id) {
    return fetchWrapper.get(`${remoteAPI}${iconAPI}/${user_id}/${icon_id}`, jwt);
}

